import * as React from 'react';

export const PlaceholderPoliceReport = (props: React.SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 799.6 500" {...props}>
		<path fill="currentColor" d="M0 0h799.6v500H0z" data-name="Rechteck 1" opacity=".2" />
		<g fill="currentColor" opacity=".8">
			<path d="M235.1 17.3h329.6v466.3H235.1z" data-name="Rechteck 2" opacity=".4" />
			<g data-name="Gruppe 2">
				<path d="M329.6 329.7h32.7v4.6h-32.7z" data-name="Rechteck 3" />
				<g data-name="Gruppe 1">
					<path d="M258.3 115.4h140v7.3h-140z" data-name="Rechteck 4" />
					<path d="M391.7 115.4h6.6v57.1h-6.6z" data-name="Rechteck 5" />
					<path d="M356 165.6h42.3v6.9H356z" data-name="Rechteck 6" />
					<path d="M356 165.6h6.3v168.8H356z" data-name="Rechteck 7" />
					<path d="M329.6 330.2h4.8v90h-4.8z" data-name="Rechteck 8" />
					<path d="M329.6 414.3h32.7v5.9h-32.7z" data-name="Rechteck 9" />
					<path d="M356 414.3h5.9v46.6H356z" data-name="Rechteck 10" />
					<path d="M257.9 453.6h104v7.3h-104z" data-name="Rechteck 11" />
				</g>
			</g>
			<g data-name="Gruppe 4">
				<path d="M437.8 329.7h32.7v4.6h-32.7z" data-name="Rechteck 12" />
				<g data-name="Gruppe 3">
					<path d="M541.9 122.6h-140v-7.3h140z" data-name="Rechteck 13" />
					<path d="M408.4 172.5h-6.6v-57h6.6z" data-name="Rechteck 14" />
					<path d="M444.1 172.5h-42.3v-6.9h42.3z" data-name="Rechteck 15" />
					<path d="M444.1 334.3h-6.3V165.5h6.3z" data-name="Rechteck 16" />
					<path d="M470.5 420.3h-4.8v-90h4.8z" data-name="Rechteck 17" />
					<path d="M470.5 420.2h-32.7v-5.9h32.7z" data-name="Rechteck 18" />
					<path d="M444.1 460.8h-5.9v-46.6h6z" data-name="Rechteck 19" />
					<path d="M542.2 460.8h-104v-7.3h104z" data-name="Rechteck 20" />
				</g>
			</g>
			<path d="M261.2 52.4h88.5v9.7h-88.5z" data-name="Rechteck 21" opacity=".6" />
			<g data-name="Gruppe 5" opacity=".6">
				<path d="M258.3 124.5h106.1v5.2H258.3z" data-name="Rechteck 22" />
				<path d="M258.3 187H285v4.8h-26.7z" data-name="Rechteck 23" />
				<path d="M258.3 213.2h33v4.4h-33z" data-name="Rechteck 24" />
				<path d="M258.3 260.3h40.4v4.8h-40.4z" data-name="Rechteck 25" />
				<path d="M259.2 330.2h54.2v4.1h-54.2z" data-name="Rechteck 26" />
				<path d="M259.2 335.3h54.2v4.1h-54.2z" data-name="Rechteck 27" />
				<path d="M259.2 340.4h39.6v4.1h-39.6z" data-name="Rechteck 28" />
				<path d="M259.2 388.2h48.3v5.1h-48.3z" data-name="Rechteck 29" />
				<path d="M259.2 420.2h37.7v6.1h-37.7z" data-name="Rechteck 30" />
				<path d="M258.3 135.5h130.6v1H258.3z" data-name="Rechteck 31" />
				<path d="M258.3 145h130.6v1H258.3z" data-name="Rechteck 32" />
				<path d="M258.3 154.4h130.6v1H258.3z" data-name="Rechteck 33" />
				<path d="M258.3 163.5h130.6v1H258.3z" data-name="Rechteck 34" />
				<path d="M258.3 200.1h94.5v1h-94.5z" data-name="Rechteck 35" />
				<path d="M258.3 226.4h94.5v1h-94.5z" data-name="Rechteck 36" />
				<path d="M258.3 236.9h94.5v1h-94.5z" data-name="Rechteck 37" />
				<path d="M258.3 285.3h94.5v1h-94.5z" data-name="Rechteck 38" />
				<path d="M258.3 295.4h94.5v1h-94.5z" data-name="Rechteck 39" />
				<path d="M258.3 306.1h94.5v1h-94.5z" data-name="Rechteck 40" />
				<path d="M258.3 400.8h68.9v1h-68.9z" data-name="Rechteck 41" />
				<path d="M258.3 410.2h68.9v1h-68.9z" data-name="Rechteck 42" />
				<path d="M258.3 432.8h96v1h-96z" data-name="Rechteck 43" />
				<path d="M258.3 442.4h96v1h-96z" data-name="Rechteck 44" />
				<path d="M258.3 274.3h94.5v1h-94.5z" data-name="Rechteck 45" />
				<path d="M306.5 230h1v7.4h-1z" data-name="Rechteck 46" />
				<path d="M306.5 266h1v8.8h-1z" data-name="Rechteck 47" />
				<path d="M306.5 298.4h1v8.3h-1z" data-name="Rechteck 48" />
				<path d="M270.7 179.7h-9v-9h9zm-8-1h7.1v-7.1h-7.1z" data-name="Pfad 1" />
				<path d="M313.4 179.7h-9v-9h9zm-8-1h7.1v-7.1h-7.1z" data-name="Pfad 2" />
				<path d="M270.7 254.1h-9v-9h9zm-8-.9h7.1v-7.1h-7.1z" data-name="Pfad 3" />
				<path d="M313.4 254.1h-9v-9h9zm-8-.9h7.1v-7.1h-7.1z" data-name="Pfad 4" />
			</g>
			<g data-name="Gruppe 6" opacity=".6">
				<path d="M541.9 129.7H435.8v-5.2h106z" data-name="Rechteck 49" />
				<path d="M541.9 191.8h-26.7V187h26.7z" data-name="Rechteck 50" />
				<path d="M541.8 217.6h-33v-4.4h33z" data-name="Rechteck 51" />
				<path d="M541.9 265.2h-40.4v-4.8h40.4z" data-name="Rechteck 52" />
				<path d="M540.9 334.4h-54.2v-4.1h54.2z" data-name="Rechteck 53" />
				<path d="M540.9 339.4h-54.2v-4h54.2z" data-name="Rechteck 54" />
				<path d="M541 344.4h-39.7v-4H541z" data-name="Rechteck 55" />
				<path d="M541 393.3h-48.4v-5H541z" data-name="Rechteck 56" />
				<path d="M541 426.4h-37.8v-6.1H541z" data-name="Rechteck 57" />
				<path d="M411.2 135.5h130.6v1H411.2z" data-name="Rechteck 58" />
				<path d="M411.2 145h130.6v1H411.2z" data-name="Rechteck 59" />
				<path d="M411.2 154.4h130.6v1H411.2z" data-name="Rechteck 60" />
				<path d="M411.2 163.5h130.6v1H411.2z" data-name="Rechteck 61" />
				<path d="M447.3 200.1h94.5v1h-94.5z" data-name="Rechteck 62" />
				<path d="M447.3 226.4h94.5v1h-94.5z" data-name="Rechteck 63" />
				<path d="M447.3 236.9h94.5v1h-94.5z" data-name="Rechteck 64" />
				<path d="M447.3 285.3h94.5v1h-94.5z" data-name="Rechteck 65" />
				<path d="M447.3 295.4h94.5v1h-94.5z" data-name="Rechteck 66" />
				<path d="M447.3 306.1h94.5v1h-94.5z" data-name="Rechteck 67" />
				<path d="M473 400.8h68.9v1H473z" data-name="Rechteck 68" />
				<path d="M473 410.2h68.9v1H473z" data-name="Rechteck 69" />
				<path d="M445.9 432.8h96v1h-96z" data-name="Rechteck 70" />
				<path d="M445.9 442.4h96v1h-96z" data-name="Rechteck 71" />
				<path d="M447.3 274.3h94.5v1h-94.5z" data-name="Rechteck 72" />
				<path d="M492.6 230h1v7.4h-1z" data-name="Rechteck 73" />
				<path d="M492.6 266h1v8.8h-1z" data-name="Rechteck 74" />
				<path d="M492.6 298.4h1v8.3h-1z" data-name="Rechteck 75" />
				<path d="M538.4 179.7h-9v-9h9zm-8.1-1h7.1v-7.1h-7.1z" data-name="Pfad 5" />
				<path d="M495.7 179.7h-9v-9h9zm-8-1h7.1v-7.1h-7.1z" data-name="Pfad 6" />
				<path d="M538.4 254.1h-9v-9h9zm-8.1-.9h7.1v-7.1h-7.1z" data-name="Pfad 7" />
				<path d="M495.7 254.1h-9v-9h9zm-8-.9h7.1v-7.1h-7.1z" data-name="Pfad 8" />
			</g>
			<g data-name="Gruppe 7" opacity=".6">
				<path
					d="M540.9 79.3v32.4H259.2V79.3h281.7m.9-1H258.3v34.3h283.5V78.3z"
					data-name="Pfad 9"
				/>
				<path d="M258.3 91.9h283.6v1H258.3z" data-name="Rechteck 76" />
				<path d="M270.7 108h-9v-9h9zm-8-1h7.1v-7.1h-7.1z" data-name="Pfad 10" />
				<path d="M289.5 108h-9v-9h9zm-8-1h7.1v-7.1h-7.1z" data-name="Pfad 11" />
				<path d="M495.8 91h-9v-9h9zm-8.1-1h7.1v-7h-7.1z" data-name="Pfad 12" />
				<path d="M526.5 91h-9v-9h9zm-8.1-1h7.1v-7h-7.1z" data-name="Pfad 13" />
			</g>
			<g data-name="Gruppe 8">
				<path d="M391.2 179.7h17.2v2.1h-17.2z" data-name="Rechteck 77" opacity=".6" />
				<path d="M389.1 187h21.4v2.1h-21.4z" data-name="Rechteck 78" opacity=".6" />
				<path d="M393.9 194.3h12v2.1h-12z" data-name="Rechteck 79" opacity=".6" />
				<path d="M393.9 202.6h12v2.1h-12z" data-name="Rechteck 80" opacity=".6" />
				<path d="M373.6 210.2h52.5v2.1h-52.5z" data-name="Rechteck 81" opacity=".6" />
				<path d="M389.6 213.7h20.5v2.1h-20.5z" data-name="Rechteck 82" opacity=".6" />
				<path d="M375.6 217.7h48.5v2.1h-48.5z" data-name="Rechteck 83" opacity=".6" />
				<path d="M390.2 221.3h19.3v2.1h-19.3z" data-name="Rechteck 84" opacity=".6" />
				<path d="M378.3 227.6h43v2.1h-43z" data-name="Rechteck 85" opacity=".6" />
				<path d="M384.3 235.4h31v2.1h-31z" data-name="Rechteck 86" opacity=".6" />
				<path d="M391.6 243.2h16.5v2.1h-16.5z" data-name="Rechteck 87" opacity=".6" />
				<path d="M381.2 249.7h37.4v2.1h-37.4z" data-name="Rechteck 88" opacity=".6" />
				<path d="M381.2 253.5h37.4v2.1h-37.4z" data-name="Rechteck 89" opacity=".6" />
				<path d="M385.8 259.9h28v2.1h-28z" data-name="Rechteck 90" opacity=".6" />
				<path d="M392 267.3h15.6v2.1H392z" data-name="Rechteck 91" opacity=".6" />
				<path d="M390.5 275.7h18.6v2.1h-18.6z" data-name="Rechteck 92" opacity=".6" />
				<path d="M390.5 283.1h18.6v2.1h-18.6z" data-name="Rechteck 93" opacity=".6" />
				<path d="M390.5 291.2h18.6v2.1h-18.6z" data-name="Rechteck 94" opacity=".6" />
				<path d="M380.5 299.6h38.7v2.1h-38.7z" data-name="Rechteck 95" opacity=".6" />
				<path d="M387.2 307.4h25.2v2.1h-25.2z" data-name="Rechteck 96" opacity=".6" />
				<path d="M376.6 315.8H423v2.1h-46.4z" data-name="Rechteck 97" opacity=".6" />
				<path d="M375.9 324.5h47.8v2.1h-47.8z" data-name="Rechteck 98" opacity=".6" />
				<path d="M383.3 334.4h33.1v4.3h-33.1z" data-name="Rechteck 99" opacity=".6" />
				<path d="M380.5 415.9h38.7v4.3h-38.7z" data-name="Rechteck 100" opacity=".6" />
				<path d="M383.3 422h33.1v4.3h-33.1z" data-name="Rechteck 101" opacity=".6" />
			</g>
		</g>
	</svg>
);
